import { render } from "./InsolvencyModal.vue?vue&type=template&id=53e8e16a&scoped=true"
import script from "./InsolvencyModal.vue?vue&type=script&lang=js"
export * from "./InsolvencyModal.vue?vue&type=script&lang=js"

import "./InsolvencyModal.vue?vue&type=style&index=0&id=53e8e16a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e8e16a"]])

export default __exports__